import { EmptyStateComponent, emptyStateTemplate } from './EmptyState';
import styles from './EmptyState.styles.scss';
export const emptyStateDefinition = { baseName: 'empty-state', template: emptyStateTemplate, styles };
export const chameleonEmptyState = EmptyStateComponent.compose(emptyStateDefinition);
